var merge = require('lodash/merge');
var constants = require('./survey/constants');
var surveyStateHistoryConstants = require('./surveyStateHistory/constants');

const initialState = {
    surveys: {
        "clinical_trials_opt_in_survey": {
            "id": "clinical_trials_opt_in_survey",
            "name": "CT",
            "description": "Clinical Trials Opt-In",
            "isActive": true,
            "sequence": ["CT1"],
            "fields": ["CT1"]
        }
    },
    symptoms: {},
    contexts: {},
    sequences: {
        "CT1": {
            "field": "CT1",
            "enabled": true
        }
    },
    fields: {
        "CT1": {
            "name": "CT1",
            "label": "Would you like to receive information regarding clinical trials near you?",
            "sublabel": "",
            "type": "select",
            "isRequired": true,
            "allowMulti": false,
            "isActive": true,
            "imageUrl": "",
            "helpText": "",
            "navigation": [],
            "order": 1,
            "choices": [{
                "label": "Yes",
                "tag": "yes",
                "value": 0
            }, {
                "label": "Not now",
                "tag": "not_now",
                "value": 1
            }]
        }
    }
};

function entities(state, action) {
    var newstate;

    if (typeof state === 'undefined') {
        return initialState
    }
    if (action.entities) {
        return merge({}, state, action.entities);
    }

    if (action.type === constants.TOGGLE_SEQUENCE) {
        newstate = Object.assign({},state);
        newstate.sequences[action.sequenceId].enabled = action.enabled;
        return newstate;
    }

    if (action.type === constants.CHANGE_SEQUENCE) {
        newstate = Object.assign({},state);
        newstate.surveys[action.surveyId].sequence = action.sequence;
        return newstate;
    }

    if (action.type === surveyStateHistoryConstants.GO_PREVIOUS_SURVEY_STATE) {
        return Object.assign({}, state, action.previousSurveyState.entities);
    }

    return state;
}

module.exports = entities;



// WEBPACK FOOTER //
// ./src/common/modules/entities.js